export default __webpack_public_path__ + "static/flex-781c55beeae7f1e2969b5adcd314d38d.png";